module.exports = __webpack_public_path__ + "static/media/logo-w.a87d474b.png";